/**
 * DAS SPALTENRASTER DES ANGEBOTS-BUILDERS — EINE QUELLE FÜR KOPFZEILE UND ZEILEN.
 *
 * Aus Entwurf 43: `30px minmax(0,1fr) 170px 64px 96px 100px 96px` mit 12 px Spaltenabstand und
 * 18 px Rand, also: Griff · Position · Kennzeichen · Menge · Einzelpreis · Summe · Aktionen.
 *
 * WARUM DAS EINE EIGENE DATEI IST
 *
 * Weil es vorher zwei Raster gab, die einander ähnlich sahen. Die Kopfzeile in
 * `PositionsListe.tsx` benutzte ein Raster, jede Zeile in `ItemRow.tsx` baute ihre Spalten mit
 * festen Breiten daneben nach. Beim Nachmessen stellte sich heraus: **die Spaltennamen standen
 * 16 px neben ihren Spalten.** Das ist genau der Befund aus dem Entwurf („Menge / Einzelpreis /
 * Summe stehen nicht untereinander"), nur eine Ebene höher — und er war mit zwei getrennten
 * Definitionen nicht dauerhaft zu beheben, sondern nur einmalig auszugleichen.
 *
 * Zwei Stellen, die dasselbe Raster beschreiben, sind zwei Wahrheiten über dieselbe Fläche.
 * Deshalb steht es hier, und beide lesen es.
 *
 * KEIN ZYKLUS: `PositionsListe` importiert `ItemRow`; läge das Raster in einer der beiden
 * Dateien, müsste eine von ihnen aus der anderen lesen.
 *
 * SCHMALER SCHIRM: unter 640 px gibt es nur Griff und Inhalt. Kennzeichen, Zahlen und Aktionen
 * rutschen darunter (`col-start-2`) — eine siebenspaltige Tabelle auf einem Telefon ist keine
 * Ordnung, sondern Gedränge. Ab 640 px greift das Raster des Entwurfs.
 */

/** Nur die Spaltendefinition — für Elemente, die ihren Rand selbst mitbringen (die Kopfzeile). */
export const RASTER_43_SPALTEN =
  "grid-cols-[30px_minmax(220px,1fr)] sm:grid-cols-[30px_minmax(220px,1fr)_150px_60px_88px_96px_96px]";

/** Das vollständige Raster inklusive Spaltenabstand und Seitenrand — für die Zeilen. */
export const RASTER_43 = `grid ${RASTER_43_SPALTEN} gap-x-[12px] px-[18px]`;
